import { updatedEntities, denormalisedEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';

import { fetchCurrentUser } from '../../ducks/user.duck';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { duplicateListing as duplicateListingApi } from '../../util/api';
import * as log from '../../util/log';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 42 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const RESULT_PAGE_SIZE = 42;

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/ManageListingsPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/ManageListingsPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/ManageListingsPage/FETCH_LISTINGS_ERROR';

export const OPEN_LISTING_REQUEST = 'app/ManageListingsPage/OPEN_LISTING_REQUEST';
export const OPEN_LISTING_SUCCESS = 'app/ManageListingsPage/OPEN_LISTING_SUCCESS';
export const OPEN_LISTING_ERROR = 'app/ManageListingsPage/OPEN_LISTING_ERROR';

export const CLOSE_LISTING_REQUEST = 'app/ManageListingsPage/CLOSE_LISTING_REQUEST';
export const CLOSE_LISTING_SUCCESS = 'app/ManageListingsPage/CLOSE_LISTING_SUCCESS';
export const CLOSE_LISTING_ERROR = 'app/ManageListingsPage/CLOSE_LISTING_ERROR';

export const ADD_OWN_ENTITIES = 'app/ManageListingsPage/ADD_OWN_ENTITIES';
export const CLEAR_OPEN_LISTING_ERROR = 'app/ManageListingsPage/CLEAR_OPEN_LISTING_ERROR';

export const DELETE_LISTING = 'app/ManageListingsPage/DELETE_LISTING';
export const DELETE_LISTING_LOADING = 'app/ManageListingsPage/DELETE_LISTING_LOADING';
export const DELETE_LISTING_ERROR = 'app/ManageListingsPage/DELETE_LISTING_ERROR';


export const FETCH_SALES_REQUEST = 'app/ManageListingsPage/FETCH_SALES_REQUEST';
export const FETCH_SALES_SUCCESS = 'app/ManageListingsPage/FETCH_SALES_SUCCESS';
export const FETCH_SALES_ERROR = 'app/ManageListingsPage/FETCH_SALES_ERROR';

export const FETCH_TOTAL_EARNINGS_REQUEST = 'app/ManageListingsPage/FETCH_TOTAL_EARNINGS_REQUEST';
export const FETCH_TOTAL_EARNINGS_SUCCESS = 'app/ManageListingsPage/FETCH_TOTAL_EARNINGS_SUCCESS';
export const FETCH_TOTAL_EARNINGS_ERROR = 'app/ManageListingsPage/FETCH_TOTAL_EARNINGS_ERROR';

export const DUPLICATE_LISTING_REQUEST = 'app/ManageListingsPage/DUPLICATE_LISTING_REQUEST';
export const DUPLICATE_LISTING_SUCCESS = 'app/ManageListingsPage/DUPLICATE_LISTING_SUCCESS';
export const DUPLICATE_LISTING_ERROR = 'app/ManageListingsPage/DUPLICATE_LISTING_ERROR';

export const FETCH_ACTIVE_LISTING_REQUEST = 'app/ManageListingsPage/FETCH_ACTIVE_LISTING_REQUEST';
export const FETCH_ACTIVE_LISTING_SUCCESS = 'app/ManageListingsPage/FETCH_ACTIVE_LISTING_SUCCESS';
export const FETCH_ACTIVE_LISTING_ERROR = 'app/ManageListingsPage/FETCH_ACTIVE_LISTING_ERROR';

import { deleteListing } from '../../util/api';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  queryParams: null,
  queryInProgress: false,
  queryListingsError: null,
  currentPageResultIds: [],
  ownEntities: {},
  openingListing: null,
  openingListingError: null,
  closingListing: null,
  closingListingError: null,
  deleteListingLoading: false,
  deleteListingError: null,
  fetchSalesError: null,
  fetchSalesInProgress: false,
  TotalSoldItems: 0,
  fetchTotalEarningsError: null,
  FetchTotalEarningsInProgress: false,
  TotalEarnings: 0,
  duplicateListingInProgress: false,
  duplicateListingError: null,
  dublicatingListingId: null,
  fetchActiveListingsInProgress: false,
  fetchActiveListingsError: null,
  activeListings: 0,

};

const resultIds = data => data.data.map(l => l.id);

const merge = (state, sdkResponse) => {
  const apiResponse = sdkResponse.data;
  return {
    ...state,
    ownEntities: updatedEntities({ ...state.ownEntities }, apiResponse),
  };
};

const updateListingAttributes = (state, listingEntity) => {
  const oldListing = state.ownEntities.ownListing[listingEntity.id.uuid];
  const updatedListing = { ...oldListing, attributes: listingEntity.attributes };
  const ownListingEntities = {
    ...state.ownEntities.ownListing,
    [listingEntity.id.uuid]: updatedListing,
  };
  return {
    ...state,
    ownEntities: { ...state.ownEntities, ownListing: ownListingEntities },
  };
};

const manageListingsPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case CLEAR_OPEN_LISTING_ERROR:
      return {
        ...state,
        openingListing: null,
        openingListingError: null,
      };

    case FETCH_LISTINGS_REQUEST:
      return {
        ...state,
        queryParams: payload.queryParams,
        queryInProgress: true,
        queryListingsError: null,
        currentPageResultIds: [],
      };
    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        queryInProgress: false,
      };
    case FETCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryListingsError: payload };

    case OPEN_LISTING_REQUEST:
      return {
        ...state,
        openingListing: payload.listingId,
        openingListingError: null,
      };
    case OPEN_LISTING_SUCCESS:
      return {
        ...updateListingAttributes(state, payload.data),
        openingListing: null,
      };
    case OPEN_LISTING_ERROR: {
      // eslint-disable-next-line no-console
      console.error(payload);
      return {
        ...state,
        openingListing: null,
        openingListingError: {
          listingId: state.openingListing,
          error: payload,
        },
      };
    }

    case CLOSE_LISTING_REQUEST:
      return {
        ...state,
        closingListing: payload.listingId,
        closingListingError: null,
      };
    case CLOSE_LISTING_SUCCESS:
      return {
        ...updateListingAttributes(state, payload.data),
        closingListing: null,
      };
    case CLOSE_LISTING_ERROR: {
      // eslint-disable-next-line no-console
      console.error(payload);
      return {
        ...state,
        closingListing: null,
        closingListingError: {
          listingId: state.closingListing,
          error: payload,
        },
      };
    }

    case ADD_OWN_ENTITIES:
      return merge(state, payload);

    case DELETE_LISTING:
      // const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, deleteListingLoading: false };
    case DELETE_LISTING_LOADING:
      return { ...state, deleteListingLoading: true };
    case DELETE_LISTING_ERROR:
      return { ...state, deleteListingLoading: false, deleteListingError: payload };

    case FETCH_SALES_REQUEST:
      return {
        ...state,
        fetchSalesInProgress: true,
        fetchSalesError: null
      };

    case FETCH_SALES_SUCCESS:
      return {
        ...state,
        fetchSalesInProgress: false,
        TotalSoldItems: payload?.data?.meta?.totalItems,
      };

    case FETCH_SALES_ERROR:
      console.error(payload);
      return {
        ...state,
        fetchSalesInProgress: false,
        fetchSalesError: payload
      };
    case FETCH_TOTAL_EARNINGS_REQUEST:
      return {
        ...state,
        FetchTotalEarningsInProgress: true,
        fetchTotalEarningsError: null
      };
    case FETCH_TOTAL_EARNINGS_SUCCESS:
      return {
        ...state,
        FetchTotalEarningsInProgress: false,
        TotalEarnings: payload / 100,
      };
    case FETCH_TOTAL_EARNINGS_ERROR:
      console.error(payload);
      return {
        ...state,
        FetchTotalEarningsInProgress: false,
        fetchTotalEarningsError: payload
      };


    case FETCH_ACTIVE_LISTING_REQUEST:
      return {
        ...state,
        fetchActiveListingsInProgress: true,
        fetchActiveListingsError: null,
      };
    case FETCH_ACTIVE_LISTING_SUCCESS:
      return {
        ...state,
        fetchActiveListingsInProgress: false,
        fetchActiveListingsError: null,
        activeListings: payload,
      };
    case FETCH_ACTIVE_LISTING_ERROR:
      console.error(payload);
      return {
        ...state,
        fetchActiveListingsInProgress: false,
        fetchActiveListingsError: payload,
      };


    case DUPLICATE_LISTING_REQUEST:
      return {
        ...state,
        duplicateListingInProgress: true,
        duplicateListingError: null,
        dublicatingListingId: payload.listingId
      };
    case DUPLICATE_LISTING_SUCCESS:
      return {
        ...state,
        duplicateListingInProgress: false,
        dublicatingListingId: null,
      };
    case DUPLICATE_LISTING_ERROR:
      console.error(payload);
      return {
        ...state,
        duplicateListingInProgress: false,
        duplicateListingError: payload,
        dublicatingListingId: null
      };


    default:
      return state;
  }
};

export default manageListingsPageReducer;

// ================ Selectors ================ //

/**
 * Get the denormalised own listing entities with the given IDs
 *
 * @param {Object} state the full Redux store
 * @param {Array<UUID>} listingIds listing IDs to select from the store
 */
export const getOwnListingsById = (state, listingIds) => {
  const { ownEntities } = state.ManageListingsPage;
  const resources = listingIds.map(id => ({
    id,
    type: 'ownListing',
  }));
  const throwIfNotFound = false;
  return denormalisedEntities(ownEntities, resources, throwIfNotFound);
};

// ================ Action creators ================ //

export const clearOpenListingError = () => ({
  type: CLEAR_OPEN_LISTING_ERROR,
});

// This works the same way as addMarketplaceEntities,
// but we don't want to mix own listings with searched listings
// (own listings data contains different info - e.g. exact location etc.)
export const addOwnEntities = sdkResponse => ({
  type: ADD_OWN_ENTITIES,
  payload: sdkResponse,
});

export const openListingRequest = listingId => ({
  type: OPEN_LISTING_REQUEST,
  payload: { listingId },
});

export const openListingSuccess = response => ({
  type: OPEN_LISTING_SUCCESS,
  payload: response.data,
});

export const openListingError = e => ({
  type: OPEN_LISTING_ERROR,
  error: true,
  payload: e,
});

export const closeListingRequest = listingId => ({
  type: CLOSE_LISTING_REQUEST,
  payload: { listingId },
});

export const closeListingSuccess = response => ({
  type: CLOSE_LISTING_SUCCESS,
  payload: response.data,
});

export const closeListingError = e => ({
  type: CLOSE_LISTING_ERROR,
  error: true,
  payload: e,
});

export const queryListingsRequest = queryParams => ({
  type: FETCH_LISTINGS_REQUEST,
  payload: { queryParams },
});

export const queryListingsSuccess = response => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const queryListingsError = e => ({
  type: FETCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const deleteListingSuccess = transaction => ({
  type: DELETE_LISTING,
  payload: transaction.data,
});

export const deleteListingError = error => ({
  type: DELETE_LISTING_ERROR,
  error: true,
  payload: error,
});

export const fetchTotalEarningsRequest = () => ({
  type: FETCH_TOTAL_EARNINGS_REQUEST,
});

export const fetchTotalEarningsSuccess = (totalAmount) => ({
  type: FETCH_TOTAL_EARNINGS_SUCCESS,
  payload: totalAmount,
});

export const fetchTotalEarningsError = (error) => ({
  type: FETCH_TOTAL_EARNINGS_ERROR,
  payload: error,
});

export const fetchSalesRequest = () => ({
  type: FETCH_SALES_REQUEST,
});

export const fetchSalesSuccess = (response) => ({
  type: FETCH_SALES_SUCCESS,
  payload: response,
});

export const fetchSalesError = (error) => ({
  type: FETCH_SALES_ERROR,
  payload: error,
});

export const dublicateListingRequest = listingId => ({
  type: DUPLICATE_LISTING_REQUEST,
  payload: { listingId },
});

export const dublicateListingSuccess = (response) => ({
  type: DUPLICATE_LISTING_SUCCESS,
  payload: response,
});

export const dublicateListingError = (error) => ({
  type: DUPLICATE_LISTING_ERROR,
  payload: error,
});

export const fetchActiveListingRequest = () => ({
  type: FETCH_ACTIVE_LISTING_REQUEST,
});

export const fetchActiveListingSuccess = (response) => ({
  type: FETCH_ACTIVE_LISTING_SUCCESS,
  payload: response,
});

export const fetchActiveListingError = (error) => ({
  type: FETCH_ACTIVE_LISTING_ERROR,
  payload: error,
});

// Throwing error for new (loadData may need that info)
export const queryOwnListings = queryParams => (dispatch, getState, sdk) => {
  dispatch(queryListingsRequest(queryParams));

  const { perPage, ...rest } = queryParams;
  const params = { ...rest, perPage };

  return sdk.ownListings
    .query(params)
    .then(response => {
      dispatch(addOwnEntities(response));
      dispatch(queryListingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(queryListingsError(storableError(e)));
      throw e;
    });
};

export const closeListing = listingId => (dispatch, getState, sdk) => {
  dispatch(closeListingRequest(listingId));

  return sdk.ownListings
    .close({ id: listingId }, { expand: true })
    .then(response => {
      dispatch(closeListingSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(closeListingError(storableError(e)));
    });
};

export const openListing = listingId => (dispatch, getState, sdk) => {
  dispatch(openListingRequest(listingId));

  return sdk.ownListings
    .open({ id: listingId }, { expand: true })
    .then(response => {
      dispatch(openListingSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(openListingError(storableError(e)));
    });
};

export const removeListing = (listingId, isDraft) => (dispatch, getState, sdk) => {
  dispatch({ type: DELETE_LISTING_LOADING });

  deleteListing(listingId)
    .then(async responseListing => {
      if (isDraft) {
        return window.location.reload();
      }
      await sdk.ownListings
        .close({ id: listingId }, { expand: true })
        .then(response => {
          window.location.reload();
          dispatch(deleteListingSuccess(responseListing.data));
        })
        .catch(e => {
          dispatch(deleteListingError(storableError(e)));
        });
    })
    .catch(e => {
      dispatch(deleteListingError(storableError(e)));
      log.error(e, 'delete-listing-failed', {});
    });
};

export const fetchActiveListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchActiveListingRequest());

  const params = {
    page: 1,
    perPage: 1,
    states: "published",
    minStock:1,
  };

  return sdk.ownListings
    .query(params)
    .then(response => {
      dispatch(fetchActiveListingSuccess(response.data.meta.totalItems));
      return response;
    })
    .catch(e => {
      dispatch(fetchActiveListingError(storableError(e)));
      throw e;
    });
};


export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const page = queryParams.page || 1;
  dispatch(clearOpenListingError());

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return Promise.all([
    dispatch(fetchCurrentUser()),
    dispatch(
      queryOwnListings({
        ...queryParams,
        page,
        perPage: RESULT_PAGE_SIZE,
        include: ['images', 'currentStock'],
        'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        'limit.images': 1,
      })
    ),
    dispatch(fetchActiveListings()),
  ])
    .then(response => {
      // const currentUser = response[0]?.data?.data;
      const ownListings = response[1]?.data?.data;
      return ownListings;
    })
    .catch(e => {
      throw e;
    });

};

export const fetchSoldItems = () => {
  return (dispatch, getState, sdk) => {
    const onlyFilter = 'sale';
    const lastTransitionsFilter = getAllTransitionsForEveryProcess().filter(e =>
      !(
        e === "transition/request-payment" ||
        e === "transition/expire-payment" ||
        e === "transition/cancel-from-disputed" ||
        e === "transition/auto-cancel-from-disputed" ||
        e === "transition/cancel" ||
        e === "transition/auto-cancel" ||
        e === "transition/request-payment-after-inquiry"
      )
    );

    const apiQueryParams = {
      only: onlyFilter,
      lastTransitions: lastTransitionsFilter,
      page: 1,
      perPage: 1,
    };

    dispatch(fetchSalesRequest());

    return sdk.transactions
      .query(apiQueryParams)
      .then(response => {
        dispatch(fetchSalesSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(fetchSalesError(error));
        throw error;
      });
  };
};

export const fetchTotalEarnings = () => {
  return async (dispatch, getState, sdk) => {
    const onlyFilter = 'sale';

    const lastTransitionsFilter = getAllTransitionsForEveryProcess().filter(e =>
    (
      e === "transition/auto-complete" ||
      e === "transition/review-1-by-customer" ||
      e === "transition/review-1-by-provider" ||
      e === "transition/review-2-by-customer" ||
      e === "transition/review-2-by-provider" ||
      e === "transition/expire-customer-review-period" ||
      e === "transition/expire-provider-review-period" ||
      e === "transition/expire-review-period"
    )
    );

    const baseQueryParams = {
      only: onlyFilter,
      lastTransitions: lastTransitionsFilter,
      perPage: 100,
    };

    dispatch(fetchTotalEarningsRequest());

    try {
      const firstResponse = await sdk.transactions.query({ ...baseQueryParams, page: 1 });
      const transactions = firstResponse.data.data;
      const totalPages = firstResponse.data.meta.totalPages;

      const fetchPage = page =>
        sdk.transactions.query({ ...baseQueryParams, page }).then(res => res.data.data);

      const pageFetches = [];
      for (let page = 2; page <= totalPages; page++) {
        pageFetches.push(fetchPage(page));
      }

      const otherPages = await Promise.all(pageFetches);
      const allTransactions = transactions.concat(...otherPages);

      const totalEarnings = allTransactions.reduce((sum, tx) => {
        const payout = tx.attributes?.payoutTotal?.amount || 0;
        return sum + payout;
      }, 0);

      dispatch(fetchTotalEarningsSuccess(totalEarnings));
    } catch (error) {
      dispatch(fetchTotalEarningsError(error));
      throw error;
    }
  };
};

export const duplicateListing = (listingId) => {
  return async (dispatch, getState, sdk) => {
    dispatch(dublicateListingRequest(listingId));
    try {
      await duplicateListingApi({ listingId: listingId.uuid });
      dispatch(fetchSalesSuccess());
      window.location.reload();
    }
    catch (error) {
      dispatch(dublicateListingError())
      throw error;
    }
  }
}